<template>
  <div class="px-4 py-2 container-fluid">
    <div class="row mt-2">
      <div class="col-12">
        <div class="card ficha-buscador mt-4 mb-4">
          <div class="titulo">
            <h5 class="mb-0" style="display:inline-block;">Farmacia {{ farmacia.Siglas }}</h5>
          </div>
          <div class="descarga" style="right:10px;">
            <p @click="volverAtras"><i class="fa fa-arrow-left" aria-hidden="true"></i></p>
          </div>
        </div>
        <div class="card">
          <div class="row">
            <div class="col-6">
              <div ref="mapa" id="map" class="mapa"></div>
            </div>
            <div class="col-6 pt-4 pb-4 mt-8 mb-8 detalles">
              <p class="m-0"><span>Matrícula:</span>{{ farmacia.Siglas }}</p>
              <p class="m-0"><span>Titular:</span>{{ farmacia.Titulares }}</p>
              <p class="m-0"><span>Dirección:</span>{{ farmacia.Direccion }}</p>
              <p class="m-0"><span>Parroquia:</span>{{ farmacia.Parroquia }}</p>
              <p class="m-0"><span>Concello:</span>{{ farmacia.CodigoPostal }} {{ farmacia.Concello }}</p>
              <p class="m-0"><span>Provincia:</span>{{ farmacia.Provincia }}</p>
              <p class="m-0"><span>Teléfono:</span>{{ farmacia.Telefono }}</p>
              <p class="m-0"><span>Fec.últ.cambio:</span>{{ farmacia.Fecha }}</p>
            </div>
          </div>
        </div>
        <div class="card mt-4 mb-4">
          <div class="px-4 pb-0 card-body">
            <div class="table-responsive">
              <p class="mb-0" style="font-size:1.3rem;font-weight:600;color:var(--bs-analiza-dark);">Cambios de datos:</p>
              <table id="cambios-list" class="table table-flush table-normal">
                <thead class="thead-light">
                  <tr>
                    <th>Fecha del cambio</th>
                    <th>Datos cambiados</th>
                  </tr>
                </thead>
                <tbody class="text-sm" v-if="cambios && cambios.length > 0">
                  <tr v-for="cambio in cambios" :key="cambio.id">
                    <td>{{ formatDate(cambio.fecha,'DD/MM/YYYY') }}</td>
                    <td>{{ cambio.cambio }}</td>
                  </tr>
                </tbody>
                <tbody class="text-sm" v-if="cambios && cambios.length === 0">
                  <tr>
                    <td colspan="2" class="text-left">Sin cambios recientes</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card ficha-proximas mt-4 mb-12">
          <div class="px-4 pb-0 card-body">
            <div class="table-responsive">
              <div class="ficha-buscador">
                <p class="mb-0" style="font-size:1.3rem;font-weight:600;color: var(--bs-analiza-dark);">Farmacias próximas:</p>
                <soft-range v-model="distancia" label="Distancia máxima" unidades="Km" :min="0" :max="50" :step="1" @range-input="onDistanciaChange"></soft-range>
                <div class="descarga" style="right:6px;position:absolute;top:6px;">
                  <p @click="descargarCSV"><i class="fa fa-download" aria-hidden="true"></i></p>
                </div>
              </div>
              <table id="proximas-list" class="table table-flush table-normal mt-5">
                <thead class="thead-light">
                  <tr>
                    <th>Matrícula</th>
                    <th>Titular</th>
                    <th>Dirección</th>
                    <th>Parroquia</th>
                    <th>Concello</th>
                    <th>Distancia</th>
                  </tr>
                </thead>
                <tbody class="text-sm" v-if="proximas && proximas.length > 0">
                  <tr v-for="p in proximas" :key="p.Matricula">
                    <td>{{ p.Siglas }}</td>
                    <td>{{ truncateText(p.Titulares,40,true) }}</td>
                    <td>{{ truncateText(p.Direccion,40,true) }}</td>
                    <td>{{ truncateText(p.Parroquia,30,true) }}</td>
                    <td>{{ truncateText(p.Concello,30,true) }}</td>
                    <td>{{ p.Distancia }}</td>
                  </tr>
                </tbody>
                <tbody class="text-sm" v-else>
                  <tr>
                    <td colspan="6" class="text-left">No hay farmacias próximas para la distancia seleccionada</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import setTooltip from "@/assets/js/tooltip.js";
import SoftRange from "@/components/SoftRange.vue";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

import { mapMutations, mapState } from "vuex";

export default {
  name: "DetalleMapa",
  components: {
    SoftRange
  },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      farmacia: {},
      cambios: [],
      map: null,
      markerLayer: null,
      lalinCoords: [42.726, -8.152],
      distancia:0,
      proximas: []
    };
  },
  computed: {
    ...mapState(["isNavFixed", "navbarFixed", "mcolor"]),
  },
  async mounted() {
    setTooltip(this.$store.state.bootstrap);
    
    this.initMap();
  },
  beforeUnmount() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.obtenerDetalleFarmacia());
  },
  methods: {
    async obtenerDetalleFarmacia() {
      try { 
        const resp = await this.$store.dispatch("farmacias/detalle", this.$route.params);
        this.farmacia = resp.farmacia;
        this.cambios = resp.cambios;
        this.farmacia.Fecha = this.formatDate(this.farmacia.Fecha);
        this.updateMarkers(this.farmacia.Latitud, this.farmacia.Longitud);
      } catch (error) {
        console.error("Error al obtener detalle de farmacia:", error.message || error);
        showSwal.methods.showSwal({
            type: "error",
            message: "Se ha producido un error: " + (error.message || error),
            width: 500,
        });
      }
    },

    initMap() {
      try {
        this.map = L.map(this.$refs.mapa, { zoomControl: true }).setView(this.lalinCoords, 8);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);

        // Fix default icon paths for webpack builds
        try {
          delete L.Icon.Default.prototype._getIconUrl;
          L.Icon.Default.mergeOptions({
            iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
            iconUrl: require("leaflet/dist/images/marker-icon.png"),
            shadowUrl: require("leaflet/dist/images/marker-shadow.png")
          });
        } catch (e) {
          // non-fatal if require fails (e.g., CDN usage)
        }

        this.markerLayer = L.featureGroup().addTo(this.map);
      } catch (e) {
        console.error("Error inicializando Leaflet:", e);
      }
    },

    updateMarkers(latitud, longitud) {  
      if (!this.map || !this.markerLayer) return;
      this.markerLayer.clearLayers();

      // icono personalizado para farmacias
      const customIcon = L.icon({
        iconUrl: require("@/assets/img/marker-farmacia.png"),
        iconSize: [50, 75],
        iconAnchor: [25, 75],
        popupAnchor: [0, -75]
      });

      const lat = parseFloat(latitud);
      const lng = parseFloat(longitud);
      const marker = L.marker([lat, lng], { icon: customIcon });
      marker.addTo(this.markerLayer);
      this.map.setView([lat, lng], 14);
    },

    async onDistanciaChange(value) {
      // Ejecutado mientras se mueve el deslizador; actualiza la tabla
      this.distancia = value;

      try {
        const payload = {
          matricula: this.$route.params.matricula,
          distancia: this.distancia
        };
        const result = await this.$store.dispatch('farmacias/listadoProximas', payload);
        this.proximas = result.proximas;
      } catch (e) {
        console.error('Error cargando farmacias próximas:', e);
      }
    },

    descargarCSV() {
      let csvContent = '\uFEFF"Matrícula";"Titular";"Dirección";"Parroquia";"Concello";"Codigo Postal";"Telefono";"Distancia";';
      csvContent += "\n"
      for (let row of this.proximas) {
        csvContent += `"${row.Siglas}";"${row.Titulares}";"${row.Direccion}";"${row.Parroquia}";"${row.Concello}";"${row.CodigoPostal}";"${row.Telefono}";"${row.Distancia}";` + "\n";
      }
      csvContent += "\n";
      let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      let link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'data.csv');

      link.click();
    },
    volverAtras() {
      this.$router.go(-1);
    },

    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
  },
};
</script>

<style lang="scss" scoped>
.mapa {
  height:100%;
  width:auto;
  vertical-align: top;
  background-size: 100% auto;
}
.cab-marco {
  width: 100%;
  height: 70vh;
  overflow-x: auto;
}
.card {    
  overflow: hidden;
  position: relative;
}
.detalles {
  span {
    font-weight: bold;
    margin-right: 5px;
    width:125px;
    display:inline-block;
    color: #333;
  }
} 
.ficha-proximas {
  min-height:120px;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background-color:transparent; 
}
::-webkit-scrollbar-thumb {
  background: #b0b0b0; 
  border-radius: 4px;
}
</style>